'use client';

import Image from 'next/image';
import Link from 'next/link';

import { IResolvedFaqCategory } from '@/src/utils/collections/faq/faq-categories.mappers';
import { ILocaleType } from '@/src/types';

interface IProps {
  categories: IResolvedFaqCategory[] | null;
  locale: ILocaleType;
}
export const FaqCategories = ({ categories, locale }: IProps) => {
  return (
    <div
      className={
        'mx-6 mb-12 grid max-w-840 grid-cols-1 gap-6 lg:mx-auto lg:grid-cols-2'
      }
    >
      {categories?.map(category => (
        <Link
          href={`/${locale.locale}/help/${category.slug}/`}
          key={`category-faq-${category.slug}`}
          className={
            'flex w-full cursor-pointer flex-row rounded-xl bg-neutral-100 p-10 text-black no-underline hover:bg-neutral-200 active:bg-neutral-300'
          }
          onClick={() => {
            window.dataLayer?.push({
              event: 'click_button',
              click_id: `/${locale.locale}/help/${category.slug}/`,
              click_label: category.title,
            });
          }}
        >
          <div className={'w-15'}>
            {category.icon && (
              <Image
                src={category.icon.icon}
                alt={category.icon.alt || ''}
                className={'mt-2'}
                width={28}
                height={28}
              />
            )}
          </div>
          <div className={'flex flex-1 flex-col'}>
            <div className={'text-2xl font-bold'}>{category.title}</div>
            <div className={'text-xl [&_p]:inline'}>
              {category.items?.length || 0} {category.articlesText}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};
